<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row v-if="loaded" class="mx-0 mb-3">
      <b-col>
        <b-card no-body class>
          <b-tabs card content-class="mt-3" :key="render">
            <b-tab title="Profil" active>
              <b-row>
                <b-col sm="12" lg="6">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                    
                  >
                    <b-row>
                      <b-col lg="6">
                        <mh-input
                          field="tva"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="registre"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                    
                  >
                    <b-row>
                      <b-col lg="6">
                        <mh-input
                          field="nom_soc"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="ID"
                          readonly
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col lg="12">
                        <mh-input
                          field="rechercheAdresse"
                          :readonly="!editable"
                          :table="debtor"
                          labelColsLg="2"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="12">
                        <b-row>
                          <mh-input
                            mh-class="col-12"
                            field="nom"
                            :readonly="!editable"
                            :table="debtor"
                            labelColsLg="2"
                          ></mh-input>
                          <mh-input
                            mh-class="col-6"
                            field="prenom"
                            :readonly="!editable"
                            :table="debtor"
                          ></mh-input>
                          <mh-input
                            mh-class="col-6"
                            field="date_naissance"
                            :readonly="!editable"
                            :table="debtor"
                          ></mh-input>
                        </b-row>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="titredebiteurID"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <mh-input
                        mh-class="col-3"
                        field="private"
                        :readonly="!editable"
                        :table="debtor"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="sexe"
                        :readonly="!editable"
                        :table="debtor"
                      ></mh-input>
                    </b-row>
                    <mh-input
                      field="rue1"
                      :readonly="!editable"
                      :table="debtor"
                      debounce="400"
                      :autocomplete="{ field: 'google.places' }"
                      @enter="suggestAddress($event)"
                      labelColsLg="2"
                    ></mh-input>
                    <mh-input
                      field="rue2"
                      :readonly="!editable"
                      :table="debtor"
                      labelColsLg="2"
                    ></mh-input>
                    <b-row>
                      <b-col sm="3">
                        <mh-input
                          field="localite"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col sm="3">
                        <mh-input
                          field="codepostal"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col sm="3">
                        <mh-input
                          field="pays"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col sm="3">
                        <mh-input
                          field="langue"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-table
                      v-if="!_new && debtor.debiteur_adresses.length > 0"
                      hover
                      caption-top
                      :fields="addressesFields"
                      :items="debtor.debiteur_adresses"
                      responsive
                    >
                      <template v-slot:table-caption
                        >Historique des adresses</template
                      >
                      <template v-slot:cell(date)="data">{{
                        toDate(data.item.date)
                      }}</template>
                      <template v-slot:cell(nom)="data">
                        {{ data.item.nom_soc }} {{ data.item.prenom }}
                        {{ data.item.nom }}
                      </template>
                      <template v-slot:cell(adresse)="data"
                        >{{ data.item.rue1 }} {{ data.item.rue2 }}</template
                      >
                      <template v-slot:cell(codepostal)="data"
                        >{{ data.item.codepostal }},
                        {{ data.item.localite }}</template
                      >
                    </b-table>
                  </b-card>
                </b-col>

                <b-col lg="6">
                  <b-card
                    v-if="!_new && loaded && debtor.debiteur_mandats.length > 0"
                    class="mb-2  bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                    
                  >
                    <b-table
                      id="mandatsTable"
                      striped
                      hover
                      responsive
                      :fields="mandatsFields"
                      :items="debtor.debiteur_mandats"
                    >
                      <template v-slot:cell(ID)="data">
                        <b-link
                          :to="{
                            name: 'warrantView',
                            params: { id: data.item.ID },
                          }"
                        >
                          {{ data.item.ID }}
                        </b-link>
                      </template>
                      <template v-slot:cell(date_ouverture)="data">{{
                        toDate(data.item.date_ouverture)
                      }}</template>
                      <template v-slot:cell(solde_du)="data">
                        <div>
                          Solde total :
                          <span class="float-right"
                            >{{
                              Number(
                                data.item.soldeDu.soldeTotal
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            }}
                            €</span
                          >
                        </div>
                        <div>
                          Indemnités :
                          <span class="float-right"
                            >{{
                              Number(
                                data.item.soldeDu.indemniteTotal
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            }}
                            €</span
                          >
                        </div>
                        <div>
                          Payements :
                          <span class="float-right"
                            >-
                            {{
                              Number(
                                data.item.soldeDu.payementTotal
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            }}
                            €</span
                          >
                        </div>
                        <hr />
                        <div>
                          <strong>
                            Sous-total :
                            <span class="float-right"
                              >{{
                                Number(
                                  data.item.soldeDu.soldeDu
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              }}
                              €</span
                            >
                          </strong>
                        </div>
                      </template>
                      <template v-slot:bottom-row>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>
                          <strong
                            >Total :<span class="float-right"
                              >{{
                                Number(mandatsTotal).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              }}
                              €</span
                            ></strong
                          >
                        </td>
                      </template>
                    </b-table>
                  </b-card>

                  <b-card
                    class="mb-2  bg-light shadow"
                    
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-row>
                      <b-col sm="6">
                        <mh-input
                          field="telephone"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="gsm"
                          isMobileNumber
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6">
                        <mh-input
                          field="gsm_2"
                          isMobileNumber
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="gsm_3"
                          isMobileNumber
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6">
                        <mh-input
                          field="fax"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                        <mh-input
                          label="Ancien téléphone"
                          field="ancien_telephone"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="email"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                        <mh-input
                          field="autreEmail"
                          :readonly="!editable"
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                      <b-col lg="12">
                        <mh-input
                          field="url"
                          :readonly="!editable"
                          :table="debtor"
                          labelColsLg="2"
                        ></mh-input>
                      </b-col>
                    </b-row>
                  </b-card>
                  
                </b-col>
              </b-row>
            </b-tab>

            <b-tab v-if="debtor.tva.value !== '' && bceLoaded" title="BCE">
              <b-row>
                <b-col lg="4" sm="12">
                  <b-card
                    class="mb-2  bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                    
                  >
                    <b-list-group>
                      <b-list-group-item
                        variant="primary"
                        v-for="(info, index) in bce.entity"
                        :key="index"
                      >
                        <b-row>
                          <b-col lg="3">{{ index }}</b-col>
                          <b-col lg="9">
                            <div v-for="(line, i) in info" :key="i">
                              {{ line }}
                            </div>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-col>
                <b-col v-if="bceLoaded" lg="4" sm="12">
                  <b-card
                    class="mb-2  bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                    
                  >
                    <b-list-group>
                      <b-list-group-item
                        variant="primary"
                        v-for="(info, index) in bce.unity"
                        :key="index"
                      >
                        <b-row>
                          <b-col lg="3">{{ index }}</b-col>
                          <b-col lg="9">
                            <div v-for="(line, i) in info" :key="i">
                              {{ line }}
                            </div>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-col>
                <b-col v-if="publicationsLoaded" lg="4" sm="12">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                    
                  >
                    <b-table
                      v-if="publications.length > 0"
                      striped
                      hover
                      responsive
                      :fields="pubfields"
                      :items="publications"
                    >
                      <template v-slot:cell(infos)="data">
                        <div
                          v-for="(info, index) in data.item.infos"
                          :key="index"
                        >
                          {{ info }}
                        </div>
                      </template>
                      <template v-slot:cell(document)="data">
                        <span v-if="data.item.document">
                          <b-button
                            variant="info"
                            target="_blank"
                            :href="data.item.document"
                          >
                            <b-icon icon="file-earmark-arrow-down"></b-icon>
                          </b-button>
                        </span>
                      </template>
                    </b-table>
                    <b-card-body v-else>
                      <b-alert show>Pas de publications au moniteur</b-alert>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab> </b-tab>
            <b-tab
              v-if="debtor.open_warrants_diff_add.length > 0"
              title="Changement d'adresse"
            >
              <b-row>
                <b-col sm="12" lg="12">
                  <b-card
                    class="mb-2  bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                    
                  >
                    <b-row>
                      <b-col lg="12">
                        <b-table
                          :items="debtor.open_warrants_diff_add"
                          :fields="open_warrants_fields"
                          striped
                          hover
                          responsive
                        >
                          <template v-slot:cell(creancier)="data">
                            <b-link
                              :to="{
                                name: 'creditorView',
                                params: { id: data.item.creancierID },
                              }"
                            >
                              {{ data.item.creancier }}
                            </b-link>
                          </template>
                          <template v-slot:cell(ID)="data">
                            <b-link
                              :to="{
                                name: 'warrantView',
                                params: { id: data.item.ID },
                              }"
                            >
                              {{ data.item.ID }}
                            </b-link>
                          </template>
                          <template v-slot:cell(arrangementID)="data">
                            <b-link
                              v-if="data.item.arrangementID != 0"
                              :to="{
                                name: 'settlement',
                                params: { id: data.item.arrangementID },
                              }"
                            >
                              {{ data.item.arrangementID }}
                            </b-link>
                            <span v-else>N/A</span>
                          </template>
                          <template v-slot:cell(reinit_procedure)="data">
                            <b-checkbox
                              v-model="data.item.reinit_procedure"
                            ></b-checkbox>
                          </template>
                          <template v-slot:cell(update_address)="data">
                            <b-checkbox
                              v-model="data.item.update_address"
                            ></b-checkbox>
                          </template>
                        </b-table>
                      </b-col>
                      <b-col lg="12">
                        <b-button
                          v-if="
                            debtor.open_warrants_diff_add.some(
                              (x) => x.reinit_procedure
                            ) ||
                            debtor.open_warrants_diff_add.some(
                              (x) => x.update_address
                            )
                          "
                          @click="save()"
                          >Confirmer la mise à jour des adresses
                          courrier</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <template #tabs-end>
              <li v-if="editable" class="nav--item ml-auto mt--1">
                <b-button @click="save" variant="success" size="sm"
                  >Enregistrer les modifications</b-button
                >
              </li>
            </template>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import debtors from "@/services/debtors.js";
import bce from "@/services/bce.js";
import DateTime from "@/services/DateTime.js";
import MhInput from "@/components/MhInput.vue";

export default {
  name: "debtor-view",
  components: { MhInput },
  props: {
    edit: {
      type: Boolean,
      default: true,
    },
    _new: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {
        return {
          tab: "",
        };
      },
    },
  },
  data() {
    return {
      debtor: {},
      bce: {},
      id: 0,
      render: 0,
      editable: false,
      publications: {},
      new_address: false,
      open_warrants_fields: [
        {
          key: "ID",
          class: "text-center",
        },
        {
          key: "status",
          class: "text-center",
          formatter: (value) => {
            switch (value) {
              case "stopped":
                return "à l'agenda";
              case "open":
                return "ouvert";
            }
            return "";
          },
        },
        {
          key: "date_creation",
          label: "Date de création",
          formatter: (value) => this.toDate(value),
          sortable: true,
        },
        {
          key: "creancier",
          label: "Créancier",
          sortable: true,
        },
        {
          key: "arrangementID",
          label: "Arrangement",
          class: "text-center",
        },
        {
          key: "reinit_procedure",
          label: "Réinitialiser la procédure courrier",
          class: "text-center",
        },
        {
          key: "update_address",
          label: "Mettre à jour l'adresse du mandat",
          class: "text-center",
        },
      ],
      pubfields: [
        {
          key: "id",
        },
        {
          key: "timestamp",
          label: "Date",
          sortable: true,
        },
        {
          key: "infos",
          label: "Publications",
          sortable: true,
        },
        {
          key: "document",
          label: "Document",
          sortable: false,
        },
      ],
      addressesFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "nom",
          label: "Identité",
          sortable: true,
        },
        {
          key: "adresse",
          label: "Adresse",
        },
        {
          key: "codepostal",
          label: "Localité",
          sortable: true,
        },
        {
          key: "pays",
          label: "Pays",
          sortable: true,
        },
      ],

      mandatsFields: [
        {
          key: "ID",
          label: "#",
          sortable: true,
        },
        {
          key: "date_ouverture",
          label: "Date d'ouverture",
          sortable: true,
        },
        {
          key: "status",
          label: "Statut",
          sortable: true,
        },
        {
          key: "nom_soc",
          label: "Créancier",
          sortable: true,
        },
        {
          key: "solde_du",
          label: "Solde du dossier",
        },
      ],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Débiteurs",
          to: { name: "debtors" },
        },
        {
          text: "",
          active: true,
        },
      ],
      loaded: false,
      bceLoaded: false,
      publicationsLoaded: false,
    };
  },
  watch: {
    $route() {
      // react to route changes...
      this.id = this.$route.params.id;
      this.load(true);
    },
  },
  created() {
    if (this._new) {
      this.id = 0;
    } else {
      this.id = this.$route.params.id;
    }
    if (this.$store.getters.isAdmin) {
      this.editable = true;
    } else {
      this.editable = false;
    }
    this.load(true);
  },
  computed: {
    mandatsTotal() {
      return this.twoDigits(
        this.debtor.debiteur_mandats.reduce(
          (a, b) => a + parseFloat(b.soldeDu.soldeDu),
          0
        )
      );
    },
  },
  methods: {
    load(addBread = false) {
      debtors.get(this.id).then((response) => {
        this.debtor = response.data;
        this.$store.dispatch("history", {
          object: "debiteur",
          objectID: this.debtor.ID.value,
          message: "Consultation du débiteur",
          data: {},
        });
        if (addBread) {
          this.items[2] = {
            text:
              this.debtor.nom_soc.value.trim() !== ""
                ? this.debtor.nom_soc.value
                : this.debtor.prenom.value + " " + this.debtor.nom.value,
            active: true,
          };
        }

        this.loaded = true;
        bce.get(this.debtor.tva.value).then((response) => {
          this.bce = response.data;
          this.bceLoaded = true;
        });
        bce.getPublications(this.debtor.tva.value).then((response) => {
          this.publications = response.data;
          this.publicationsLoaded = true;
        });
        this.render++;
      });
    },
    suggestAddress(payload) {
      this.debtor.rue1.value = payload.route || "";
      if (payload.street_number) {
        this.debtor.rue1.value += ", " + payload.street_number;
      }
      this.debtor.rue2.value = "";
      this.debtor.localite.value = payload.city || "";
      this.debtor.pays.value = payload.country || "";
      this.debtor.codepostal.value = payload.postal_code || "";
    },
    save() {
      debtors.post(this.debtor).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Débiteur enregistré", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          if (this._new) {
            this.$router.push({
              name: "debtorEdit",
              params: { id: response.data.id },
            });
          }
          for (let el in this.debtor) {
            if (typeof this.debtor[el] == "object") {
              this.debtor[el].error = false;
            }
          }
          this.items[2] = { text: this.debtor.nom_soc.value, active: true };
          this.renderBreadCrumb++;
          if (response.data.new_address) {
            this.new_address = true;
          }
          this.load(true);
        } else if (response.data.fail) {
          for (let el in this.detbtor) {
            this.debtor[el].error = false;
          }
          response.data.fail.forEach((element) => {
            this.debtor[element.field].error = element.errors.join(" ; ");
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br/>");
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.pre-formatted {
  white-space: pre;
}
</style>